import React from 'react';
import { prepareUrl } from 'services/DataSource';

const documentTypes = {
  'doc_pedigree': 'Родословная',
  'doc_certificate': 'Сертификат',
  'doc_receipt': 'Квитанция',
}


export default function RequestDocuments({item}) {
  let docList = Object.keys(documentTypes).map(docType => {
    let list = null;
    const docs = item[docType];
    if (!docs) return null;
    if (docs.push) {
      list = docs.map(doc => {
        if (!doc || !doc.url) return null;
        return (
          <li key={doc.id}>
            <a href={prepareUrl(doc.url, true)} rel="noopener noreferrer" target="_blank" alt={doc.name || 'Документ'}>
              {doc.name || 'Документ'}
            </a>
          </li>
        );
      });
      list = <li key={docType}>{documentTypes[docType]}: <ul>{list.length ? list : 'нет'}</ul></li>
    } else {
      list = (
        <li key={docs.id}>
          {documentTypes[docType]}:&nbsp;
          <a href={prepareUrl(docs.url, true)} rel="noopener noreferrer" target="_blank" alt={docs.name || 'Документ'}>
            {docs.name || 'Документ'}
          </a>
        </li>
      )
    }
    return list;
  });
  return <ul>{docList}</ul>;
}
